// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__faJ0+","container":"DefaultLayout_container__710cf","content":"DefaultLayout_content__j12zX"};